import type { IError } from "@somewear/model";
import { cn } from "@somewear/ui";
import classNames from "classnames";
import * as React from "react";

interface IContent {
	children: React.ReactNode;
	className?: string;
}

export interface IErrorLoading {
	error?: IError;
	loading: boolean;
}

const CenterColumn: React.FunctionComponent<IContent> = (props: IContent) => (
	<div className={classNames("flex justify-center md:col-span-12", props.className)}>
		{props.children}
	</div>
);

const CenterContent: React.FunctionComponent<IContent> = (props: IContent) => (
	<div className="row">
		<CenterColumn className={props.className}>{props.children}</CenterColumn>
	</div>
);

const ErrorMessage: React.FC<{
	error?: IError | IError[];
	children?: React.ReactNode;
}> = (props) => {
	const baseClassName =
		"rounded-lg text-center text-red-500 uppercase font-sans text-sm bg-transparent";
	const error =
		Array.isArray(props.error) && props.error.length == 1 ? props.error[0] : props.error;

	return (
		<div className={cn({ hidden: !error })}>
			<div className="flex justify-center">
				{Array.isArray(error) ? (
					<ul>
						{error.map((e) => (
							<li key={e.message} className={baseClassName}>
								{e.message}
							</li>
						))}
					</ul>
				) : (
					<div className={baseClassName}>{error?.message}</div>
				)}
			</div>
		</div>
	);
};

const TitleButtonText: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => (
	<p
		{...props}
		className={classNames(
			"font-title text-white font-bold text-center text-base md:text-lg m-auto tracking-wide uppercase",
			props.className,
		)}
	/>
);

export { CenterColumn };
export { CenterContent };
export { ErrorMessage };
export { TitleButtonText };
